<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="店铺">
                  <GridSelectLi
                      style="width: 177px"
                      title="选择门店"
                      labelName="storeName"
                      labelValue="id"
                      :value="queryForm.storeId"
                      :limit="1"
                      size="small"
                      placeholder="请选择门店"
                      @getValue="getSearchValueStoreId"
                      :columns="STORE_code"
                      :searchs="STORE_search"
                      dataListUrl="/shop/store/findList"
                      entityBeanName="shopStore"
                      queryEntityUrl="/shop/store/get"
                  >
                  </GridSelectLi>
              </el-form-item>
              <el-form-item label="当天日期">
                  <el-date-picker
                      style="width: 177px;"
                      size="small"
                      v-model="queryForm.dayDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getOperationDailyStoreActivityList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addOperationDailyStoreActivity"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editOperationDailyStoreActivity(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteOperationDailyStoreActivity(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshOperationDailyStoreActivityList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="operationDailyStoreActivityList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="storeId"
        label="店铺"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dayDate"
        label="当天日期"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sendMoney"
        label="放发抵扣券数量"
      > </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkOperationDailyStoreActivity(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editOperationDailyStoreActivity(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteOperationDailyStoreActivity(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="operationDailyStoreActivityStates[operationDailyStoreActivityState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="operationDailyStoreActivity"
          ref="operationDailyStoreActivityForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="operationDailyStoreActivity.userId"-->
<!--              :disabled="operationDailyStoreActivityState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName"
                           labelValue="id" title="选择用户" :value="operationDailyStoreActivity.userId" :limit='1' size='small' placeholder='请选择用户' :disabled="operationDailyStoreActivityState == 'check'"
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="店铺"
            prop="storeId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="operationDailyStoreActivity.storeId"-->
<!--              :disabled="operationDailyStoreActivityState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectLi
                  style="width: 177px"
                  title="选择门店"
                  labelName="storeName"
                  labelValue="id"
                  :value="operationDailyStoreActivity.storeId"
                  :disabled="operationDailyStoreActivityState == 'check'"
                  :limit="1"
                  size="small"
                  placeholder="请选择门店"
                  @getValue="getValueStoreId"
                  :columns="STORE_code"
                  :searchs="STORE_search"
                  dataListUrl="/shop/store/findList"
                  entityBeanName="shopStore"
                  queryEntityUrl="/shop/store/get"
              >
              </GridSelectLi>
          </el-form-item>
          <el-form-item
            label="当天日期"
            prop="dayDate"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="operationDailyStoreActivity.dayDate"-->
<!--              :disabled="operationDailyStoreActivityState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  style="width: 177px;"
                  size="small"
                  :disabled="operationDailyStoreActivityState == 'check'"
                  v-model="operationDailyStoreActivity.dayDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="放发抵扣券数量"
            prop="sendMoney"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyStoreActivity.sendMoney"
              :disabled="operationDailyStoreActivityState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="operationDailyStoreActivityState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { STORE, STORE_SEARCH, USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectLi,
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetOperationDailyStoreActivityList();
                    this.getOperationDailyStoreActivityList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetOperationDailyStoreActivityList();
                    this.getOperationDailyStoreActivityList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户
                     storeId: '', //店铺
                     dayDate: '', //当天日期
                     sendMoney: '', //放发抵扣券数量
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                operationDailyStoreActivityState: 'add',
                operationDailyStoreActivityStates: {
                    add: '新建商家活动记录',
                    check: '查看商家活动记录',
                    edit: '修改商家活动记录'
                },

                multipleSelection: [],
                operationDailyStoreActivityList: [],
                operationDailyStoreActivity: {
                    id: '', //
                    userId: '', //用户
                    storeId: '', //店铺
                    dayDate: '', //当天日期
                    sendMoney: '', //放发抵扣券数量
                },
                btnLoading: false,
                STORE_code: STORE,
                STORE_search: STORE_SEARCH,
                USER_code: USER,
                USER_search: USER_SEARCH,
                rules: {
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    storeId: [{ required: true, message: '店铺不能为空', trigger: 'blur' }],
                    dayDate: [{ required: true, message: '当天日期不能为空', trigger: 'blur' }],
                    sendMoney: [{ required: true, message: '放发抵扣券数量不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getOperationDailyStoreActivityList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetOperationDailyStoreActivityList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.operationDailyStoreActivityList = [];
            },
            getValueUser(value){
                this.operationDailyStoreActivity.userId = value
            },
            getSearchValueUser(value){
                this.queryForm.userId = value
            },
            getValueStoreId(value){
                this.operationDailyStoreActivity.storeId = value
            },
            getSearchValueStoreId(value){
                this.queryForm.storeId = value
            },
            resetDialog() {
                this.operationDailyStoreActivityState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户
                      storeId: '', //店铺
                      dayDate: '', //当天日期
                      sendMoney: '', //放发抵扣券数量
                };
                this.getOperationDailyStoreActivityList();
            },
            closeDialog() {
                this.showDialog = false
                this.operationDailyStoreActivity = {
                      id: '', //
                      userId: '', //用户
                      storeId: '', //店铺
                      dayDate: '', //当天日期
                      sendMoney: '', //放发抵扣券数量
                };
            },
            submitForm() {
                if (this.operationDailyStoreActivityState == 'add') {
                    this.$refs.operationDailyStoreActivityForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/operation/dailystoreactivity/add`,{ ...this.operationDailyStoreActivity }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetOperationDailyStoreActivityList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.operationDailyStoreActivityState == 'edit') {
                    this.$refs.operationDailyStoreActivityForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.operationDailyStoreActivity.user
                            post(`/operation/dailystoreactivity/edit`,{ ...this.operationDailyStoreActivity }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetOperationDailyStoreActivityList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addOperationDailyStoreActivity() {
                this.showDialog = true;
                this.operationDailyStoreActivityState = 'add';
            },
            checkOperationDailyStoreActivity(operationDailyStoreActivityId) {
                console.log(operationDailyStoreActivityId);
                this.currentOperationDailyStoreActivityId = operationDailyStoreActivityId;

                this.getOperationDailyStoreActivityById();
                this.showDialog = true;
                this.operationDailyStoreActivityState = 'check';
            },
            editOperationDailyStoreActivity(operationDailyStoreActivityId) {
                console.log('operationDailyStoreActivity', operationDailyStoreActivityId);
                if (operationDailyStoreActivityId) {
                    this.currentOperationDailyStoreActivityId = operationDailyStoreActivityId;
                    this.getOperationDailyStoreActivityById();
                } else {
                    this.operationDailyStoreActivity = { ...this.operationDailyStoreActivity, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.operationDailyStoreActivityState = 'edit';
            },
            deleteOperationDailyStoreActivity(operationDailyStoreActivityId) {
                let ids = '';
                if (operationDailyStoreActivityId) {
                    ids = operationDailyStoreActivityId;
                } else {
                    ids = this.multipleSelection.map((operationDailyStoreActivity) => operationDailyStoreActivity.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/operation/dailystoreactivity/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetOperationDailyStoreActivityList();
                                this.getOperationDailyStoreActivityList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshOperationDailyStoreActivityList() {
                this.resetOperationDailyStoreActivityList();
                this.getOperationDailyStoreActivityList();
            },
            getOperationDailyStoreActivityList(query = {}) {
                this.loading = true;
                get(`/operation/dailystoreactivity/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.operationDailyStoreActivityList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getOperationDailyStoreActivityById() {
                get(`/operation/dailystoreactivity/get`,{ id: this.currentOperationDailyStoreActivityId }).then((res) =>{
                    if(res.success){
                      this.operationDailyStoreActivity = { ...this.operationDailyStoreActivity, ...res.operationDailyStoreActivity };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportOperationDailyStoreActivityList() {
                //this.btnLoading = true;
                exprotExcel(`/operation/dailystoreactivity/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/operation/dailystoreactivity/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/operation/dailystoreactivity/importData`,formData);
              this.refreshOperationDailyStoreActivityList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getOperationDailyStoreActivityList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getOperationDailyStoreActivityList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>